/**
 * Active / commonly used ISO 4217 alphabetic codes for payroll (sorted in UI).
 * @type {readonly string[]}
 */
export const ISO4217_CODES = `AED AFN ALL AMD ANG AOA ARS AUD AWG AZN BAM BBD BDT BGN BHD BIF BMD BND BOB BRL BSD BTN BWP BYN BZD CAD CDF CHF CLP CNY COP CRC CUP CVE CZK DJF DKK DOP DZD EGP ERN ETB EUR FJD FKP GBP GEL GHS GIP GMD GNF GTQ GYD HKD HNL HTG HUF IDR ILS INR IQD IRR ISK JMD JOD JPY KES KGS KHR KMF KPW KRW KWD KYD KZT LAK LBP LKR LRD LSL LYD MAD MDL MGA MKD MMK MNT MOP MRU MUR MVR MWK MXN MYR MZN NAD NGN NIO NOK NPR NZD OMR PAB PEN PGK PHP PKR PLN PYG QAR RON RSD RUB RWF SAR SBD SCR SDG SEK SGD SHP SLE SOS SRD SSP STN SVC SYP SZL THB TJS TMT TND TOP TRY TTD TWD TZS UAH UGX USD UYU UZS VES VND VUV WST XAF XCD XOF XPF YER ZAR ZMW ZWG`
  .trim()
  .split(/\s+/)
  .sort((a, b) => a.localeCompare(b));

export function currencyOptionLabel(code) {
  if (code == null || String(code).trim() === '') return '';
  const c = String(code).trim().toUpperCase();
  if (typeof Intl === 'undefined' || !Intl.DisplayNames) return c;
  try {
    const dn = new Intl.DisplayNames(['en'], { type: 'currency' });
    const name = dn.of(c);
    return name ? `${c} — ${name}` : c;
  } catch {
    return c;
  }
}

/** @returns {{ code: string, label: string }[]} */
export function currencySelectOptions() {
  return ISO4217_CODES.map((code) => ({ code, label: currencyOptionLabel(code) }));
}
